import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";

import {
  ChevronDown,
  ArrowRight,
  ArrowLeft,
  Menu,
  X,
  Globe,
  Droplets,
  Leaf,
} from "lucide-react";

const Header = () => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const [mobileServices, setMobileServices] = useState(false);
  const [mobileCategory, setMobileCategory] = useState(null);

  const oilGasServices = [
    {
      label: "Fluidos de perforación",
      path: "/oil-gas/drilling-fluids",
    },
    {
      label: "Fluidos de completamiento",
      path: "/oil-gas/completion-fluids",
    },
    {
      label: "Control de sólidos",
      path: "/oil-gas/solid-control",
    },
    {
      label: "Consultoría y optimización",
      path: "/oil-gas/consulting",
    },
    {
      label: "Productos químicos",
      path: "/oil-gas/chemical-products",
    },
  ];

  const environmentalServices = [
    {
      label: "Monitoreo ambiental",
      path: "/environmental/monitoring",
    },
    {
      label: "Análisis de laboratorio",
      path: "/environmental/laboratory",
    },
    {
      label: "Consultoría ambiental",
      path: "/environmental/consultancy",
    },
    {
      label: "Alquiler de equipos",
      path: "/environmental/equipment",
    },
    {
      label: "Investigación y Desarrollo I+D",
      path: "/environmental/investigation",
    },
    {
      label: "Descarbonización",
      path: "/environmental/decarbonization",
    },
  ];

  const closeMobileMenu = () => {
    setMobileMenu(false);
    setMobileServices(false);
    setMobileCategory(null);
  };

  const openServices = () => {
    setMobileServices(true);
    setMobileCategory(null);
  };

  const openCategory = (category) => {
    setMobileCategory(category);
  };

  const backToServices = () => {
    setMobileCategory(null);
  };

  const navLinkClass = ({ isActive }) =>
    `relative text-[13px] xl:text-[14px] 2xl:text-[15px]
     font-semibold uppercase tracking-[0.3px]
     transition-all duration-300 ${
       isActive ? "text-[#f37021]" : "text-[#1d1d1d] hover:text-[#f37021]"
     }`;

  return (
    <>
      <header className="fixed top-0 left-0 w-full z-50 bg-white/95 backdrop-blur-xl border-b border-black/5 shadow-[0_8px_30px_rgba(0,0,0,0.05)]">
        <div
          className="
            max-w-[1450px]
            mx-auto
            px-5
            sm:px-6
            lg:px-8
            h-[78px]
            sm:h-[84px]
            xl:h-[94px]
            flex
            items-center
            justify-between
          "
        >
          <Link
            to="/"
            onClick={closeMobileMenu}
            className="
              flex
              items-center
              shrink-0
              transition
              duration-300
              hover:scale-[1.02]
            "
          >
            <img
              src="/Images/gsa_logo001.webp"
              alt="Sierra Alta"
              className="
                h-[50px]
                sm:h-[56px]
                md:h-[60px]
                xl:h-[64px]
                2xl:h-[68px]
                object-contain
              "
            />
          </Link>

          <div className="hidden xl:flex items-center gap-8">
            <nav className="flex items-center gap-7">
              {/* INICIO */}
              <NavLink to="/" className={navLinkClass}>
                {({ isActive }) => (
                  <>
                    Inicio
                    {isActive && (
                      <span
                        className="
                          absolute
                          left-0
                          -bottom-3
                          w-full
                          h-[2.5px]
                          bg-[#f37021]
                          rounded-full
                        "
                      />
                    )}
                  </>
                )}
              </NavLink>

              {/* COMPAÑÍA */}
              <NavLink to="/company" className={navLinkClass}>
                {({ isActive }) => (
                  <>
                    Compañía
                    {isActive && (
                      <span
                        className="
                          absolute
                          left-0
                          -bottom-3
                          w-full
                          h-[2.5px]
                          bg-[#f37021]
                          rounded-full
                        "
                      />
                    )}
                  </>
                )}
              </NavLink>

              {/* OPERACIONES */}
              <NavLink to="/operations" className={navLinkClass}>
                {({ isActive }) => (
                  <>
                    Operaciones
                    {isActive && (
                      <span
                        className="
                          absolute
                          left-0
                          -bottom-3
                          w-full
                          h-[2.5px]
                          bg-[#f37021]
                          rounded-full
                        "
                      />
                    )}
                  </>
                )}
              </NavLink>

              {/* SOSTENIBILIDAD */}
              <NavLink to="/sustainability" className={navLinkClass}>
                {({ isActive }) => (
                  <>
                    Sostenibilidad
                    {isActive && (
                      <span
                        className="
                          absolute
                          left-0
                          -bottom-3
                          w-full
                          h-[2.5px]
                          bg-[#f37021]
                          hover:text-[#f37021]
                          rounded-full
                        "
                      />
                    )}
                  </>
                )}
              </NavLink>

              {/* Servicios */}
              <div className="relative group">
                <button
                  type="button"
                  className="
    group
    flex
    items-center
    gap-2
    text-[13px]
    xl:text-[14px]
    2xl:text-[15px]
    font-semibold
    uppercase
    tracking-[0.3px]
  "
                >
                  <span
                    className="
      text-[#1d1d1d]
      transition-colors
      duration-300
      group-hover:text-[#f37021]
    "
                  >
                    Servicios
                  </span>

                  <ChevronDown
                    className="
      w-4
      h-4
      stroke-[#1d1d1d]
      transition-all
      duration-300
      group-hover:stroke-[#f37021]
      group-hover:rotate-180
    "
                  />
                </button>

                {/* MENU */}
                <div
                  className="
    absolute
    top-[170%]
    left-1/2
    -translate-x-1/2
    w-[680px]

    opacity-0
    invisible
    translate-y-3
    scale-[0.98]

    group-hover:opacity-100
    group-hover:visible
    group-hover:translate-y-0
    group-hover:scale-100

    transition-all
    duration-300
    ease-out
    z-50
  "
                >
                  <div
                    className="
      bg-white
      rounded-2xl
      shadow-[0_30px_80px_rgba(0,0,0,0.12)]
      border
      border-gray-100
      overflow-hidden
    "
                  >
                    <div
                      className="
        grid
        grid-cols-2
        divide-x
        divide-gray-100
      "
                    >
                      {/* OIL & GAS */}
                      <div className="p-7">
                        <div className="flex items-center gap-3 mb-5">
                          <div
                            className="
              group/icon
              w-10
              h-10
              rounded-xl
              bg-orange-50
              flex
              items-center
              justify-center
              transition-all
              duration-300
            "
                          >
                            <Droplets
                              className="
                w-4
                h-4
                stroke-[#f37021]
                transition-transform
                duration-300
                group-hover/icon:scale-110
              "
                            />
                          </div>

                          <div>
                            <h3
                              className="
                text-[13px]
                font-bold
                text-[#111]
              "
                            >
                              Oil & Gas
                            </h3>

                            <p
                              className="
                text-[11px]
                text-gray-400
                mt-0.5
              "
                            >
                              Soluciones industriales
                            </p>
                          </div>
                        </div>

                        {/* SERVICIOS */}
                        <div className="space-y-1">
                          {oilGasServices.map((item) => (
                            <Link
                              key={item.path}
                              to={item.path}
                              className="
                group/item
                flex
                items-center
                justify-between
                px-3
                py-3
                rounded-xl

                text-gray-700

                hover:bg-orange-50
                hover:text-[#f37021]

                transition-all
                duration-300
              "
                            >
                              <span
                                className="
                  text-[12.5px]
                  font-medium
                  transition-colors
                  duration-300
                  group-hover/item:text-[#f37021]
                "
                              >
                                {item.label}
                              </span>

                              <ArrowRight
                                className="
                  w-3.5
                  h-3.5

                  stroke-gray-400

                  opacity-0
                  -translate-x-2

                  group-hover/item:opacity-100
                  group-hover/item:translate-x-0
                  group-hover/item:stroke-[#f37021]

                  transition-all
                  duration-300
                "
                              />
                            </Link>
                          ))}
                        </div>
                      </div>

                      {/* AMBIENTAL */}
                      <div className="p-7">
                        <div className="flex items-center gap-3 mb-5">
                          <div
                            className="
              group/icon
              w-10
              h-10
              rounded-xl
              bg-green-50
              flex
              items-center
              justify-center
              transition-all
              duration-300
            "
                          >
                            <Leaf
                              className="
                w-4
                h-4
                stroke-green-600
                transition-transform
                duration-300
                group-hover/icon:scale-110
              "
                            />
                          </div>

                          <div>
                            <h3
                              className="
                text-[13px]
                font-bold
                text-[#111]
              "
                            >
                              Ambiental
                            </h3>

                            <p
                              className="
                text-[11px]
                text-gray-400
                mt-0.5
              "
                            >
                              Gestión y sostenibilidad
                            </p>
                          </div>
                        </div>

                        {/* SERVICIOS */}
                        <div className="space-y-1">
                          {environmentalServices.map((item) => (
                            <Link
                              key={item.path}
                              to={item.path}
                              className="
                group/item
                flex
                items-center
                justify-between
                px-3
                py-3
                rounded-xl

                text-gray-700

                hover:bg-green-50
                hover:text-green-600

                transition-all
                duration-300
              "
                            >
                              <span
                                className="
                  text-[12.5px]
                  font-medium
                  transition-colors
                  duration-300
                  group-hover/item:text-green-600
                "
                              >
                                {item.label}
                              </span>

                              <ArrowRight
                                className="
                  w-3.5
                  h-3.5

                  stroke-gray-400

                  opacity-0
                  -translate-x-2

                  group-hover/item:opacity-100
                  group-hover/item:translate-x-0
                  group-hover/item:stroke-green-600

                  transition-all
                  duration-300
                "
                              />
                            </Link>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </nav>

            {/* DESKTOP ACTIONS */}
            <div className="flex items-center gap-3">
              {/* CONTACTANOS */}
              <Link
                to="/contact-us"
                className="
                  inline-flex
                  items-center
                  justify-center
                  rounded-lg
                  bg-[#ee7d32]
                  px-6
                  xl:px-7
                  py-3
                  text-[13px]
                  xl:text-[14px]
                  font-bold
                  uppercase
                  tracking-[0.3px]
                  text-white
                  whitespace-nowrap
                  transition-all
                  duration-300
                  hover:-translate-y-[2px]
                  hover:bg-[#df6e22]
                  hover:shadow-[0_12px_30px_rgba(238,125,50,0.35)]
                "
              >
                Contáctanos
              </Link>

              {/* IDIOMA */}
              <button
                type="button"
                className="
                  flex
                  items-center
                  gap-2
                  px-4
                  py-3
                  rounded-2xl
                  border
                  border-black/5
                  bg-[#fafafa]
                  hover:bg-white
                  transition-all
                  duration-300
                "
              >
                <Globe
                  className="
                    w-4
                    h-4
                    text-[#444]
                  "
                />

                <span
                  className="
                    text-[13px]
                    xl:text-[14px]
                    font-semibold
                    text-[#333]
                  "
                >
                  ESP
                </span>

                <ChevronDown
                  className="
                    w-3
                    h-3
                    text-[#666]
                  "
                />
              </button>
            </div>
          </div>

          {/* TABLET + MOBILE ACTIONS */}
          <div
            className="
              xl:hidden
              flex
              items-center
              gap-2
            "
          >
            <Link
              to="/contact-us"
              className="
                hidden
                sm:inline-flex
                items-center
                justify-center
                rounded-lg
                bg-[#ee7d32]
                px-4
                md:px-5
                py-2.5
                text-[11px]
                md:text-[12px]
                font-bold
                uppercase
                tracking-[0.3px]
                text-white
                whitespace-nowrap
                transition-all
                duration-300
                hover:bg-[#df6e22]
                hover:-translate-y-[1px]
                hover:shadow-[0_8px_20px_rgba(238,125,50,0.25)]
              "
            >
              Contáctanos
            </Link>

            <button
              type="button"
              onClick={() => {
                setMobileMenu(!mobileMenu);

                setMobileServices(false);

                setMobileCategory(null);
              }}
              aria-label="Abrir menú"
              className="
                flex
                items-center
                justify-center
                w-11
                h-11
                rounded-xl
                text-[#222]
                hover:bg-gray-50
                transition
              "
            >
              {mobileMenu ? (
                <X className="w-7 h-7" />
              ) : (
                <Menu className="w-7 h-7" />
              )}
            </button>
          </div>
        </div>

        {/* MOBILE / TABLET MENU */}
        <div
          className={`
    xl:hidden
    absolute
    top-full
    left-0
    w-full
    bg-white
    border-t
    border-gray-100
    shadow-[0_20px_50px_rgba(0,0,0,0.08)]
    transition-all
    duration-300
    ${
      mobileMenu
        ? "opacity-100 visible"
        : "opacity-0 invisible pointer-events-none"
    }
  `}
        >
          <div
            className="
      px-5
      sm:px-8
      py-5
    "
          >
            {!mobileServices && (
              <nav className="max-w-3xl mx-auto">
                {/* INICIO */}
                <NavLink
                  to="/"
                  onClick={closeMobileMenu}
                  className="
            group
            flex
            items-center
            justify-center
            sm:justify-between
            py-4
            border-b
            border-gray-100
            text-sm
            font-semibold
            uppercase
            text-[#222]
            transition-colors
            duration-300
            hover:text-[#f37021]
          "
                >
                  <span className="transition-colors duration-300 group-hover:text-[#f37021]">
                    Inicio
                  </span>
                  <ArrowRight
                    className="
              hidden
              sm:block
              w-4
              h-4
              ml-2
              stroke-[#999]
              transition-all
              duration-300
              group-hover:stroke-[#f37021]
              group-hover:translate-x-1
            "
                  />
                </NavLink>

                {/* COMPAÑÍA */}
                <NavLink
                  to="/company"
                  onClick={closeMobileMenu}
                  className="
            group
            flex
            items-center
            justify-center
            sm:justify-between
            py-4
            border-b
            border-gray-100
            text-sm
            font-semibold
            uppercase
            text-[#222]
            transition-colors
            duration-300
            hover:text-[#f37021]
          "
                >
                  <span className="transition-colors duration-300 group-hover:text-[#f37021]">
                    Compañía
                  </span>

                  <ArrowRight
                    className="
              hidden
              sm:block
              w-4
              h-4
              ml-2
              stroke-[#999]
              transition-all
              duration-300
              group-hover:stroke-[#f37021]
              group-hover:translate-x-1
            "
                  />
                </NavLink>

                {/* OPERACIONES */}
                <NavLink
                  to="/operations"
                  onClick={closeMobileMenu}
                  className="
            group
            flex
            items-center
            justify-center
            sm:justify-between
            py-4
            border-b
            border-gray-100
            text-sm
            font-semibold
            uppercase
            text-[#222]
            transition-colors
            duration-300
            hover:text-[#f37021]
          "
                >
                  <span className="transition-colors duration-300 group-hover:text-[#f37021]">
                    Operaciones
                  </span>

                  <ArrowRight
                    className="
              hidden
              sm:block
              w-4
              h-4
              ml-2
              stroke-[#999]
              transition-all
              duration-300
              group-hover:stroke-[#f37021]
              group-hover:translate-x-1
            "
                  />
                </NavLink>

                {/* SOSTENIBILIDAD */}
                <NavLink
                  to="/sustainability"
                  onClick={closeMobileMenu}
                  className="
            group
            flex
            items-center
            justify-center
            sm:justify-between
            py-4
            border-b
            border-gray-100
            text-sm
            font-semibold
            uppercase
            text-[#222]
            transition-colors
            duration-300
            hover:text-[#f37021]
          "
                >
                  <span className="transition-colors duration-300 group-hover:text-[#f37021]">
                    Sostenibilidad
                  </span>

                  <ArrowRight
                    className="
              hidden
              sm:block
              w-4
              h-4
              ml-2
              stroke-[#999]
              transition-all
              duration-300
              group-hover:stroke-[#f37021]
              group-hover:translate-x-1
            "
                  />
                </NavLink>

                {/* SERVICIOS */}
                <button
                  type="button"
                  onClick={openServices}
                  className="
            group
            w-full
            flex
            items-center
            justify-center
            sm:justify-between
            py-4
            text-sm
            font-semibold
            uppercase
            text-[#222]
            transition-colors
            duration-300
            hover:text-[#f37021]
          "
                >
                  <span className="transition-colors duration-300 group-hover:text-[#f37021]">
                    Servicios
                  </span>

                  <ArrowRight
                    className="
              w-4
              h-4
              ml-2
              stroke-[#999]
              transition-all
              duration-300
              group-hover:stroke-[#f37021]
              group-hover:translate-x-1
            "
                  />
                </button>

                {/* CONTACTANOS — SOLO MÓVIL */}
                <Link
                  to="/contact-us"
                  onClick={closeMobileMenu}
                  className="
            sm:hidden
            group
            w-full
            flex
            items-center
            justify-center
            rounded-xl
            bg-[#ee7d32]
            px-6
            py-3.5
            mt-4
            text-[13px]
            font-bold
            uppercase
            tracking-[0.3px]
            text-white
            transition-all
            duration-300
            hover:bg-[#df6e22]
            hover:shadow-[0_10px_25px_rgba(238,125,50,0.25)]
            hover:-translate-y-0.5
          "
                >
                  Contáctanos
                </Link>

                {/* IDIOMA */}
                <button
                  type="button"
                  className="
            group
            w-full
            mt-3
            flex
            items-center
            justify-center
            gap-2
            rounded-xl
            border
            border-gray-200
            bg-[#fafafa]
            px-5
            py-3.5
            text-[13px]
            font-semibold
            text-[#333]
            transition-all
            duration-300
            hover:bg-white
            hover:border-[#f37021]/30
            hover:shadow-[0_8px_20px_rgba(238,125,50,0.08)]
          "
                >
                  <Globe
                    className="
              w-4
              h-4
              stroke-[#777]
              transition-all
              duration-300
              group-hover:stroke-[#f37021]
              group-hover:rotate-12
            "
                  />

                  <span
                    className="
              transition-colors
              duration-300
              group-hover:text-[#f37021]
            "
                  >
                    ESP
                  </span>

                  <ChevronDown
                    className="
              w-3.5
              h-3.5
              stroke-[#777]
              transition-all
              duration-300
              group-hover:stroke-[#f37021]
              group-hover:translate-y-0.5
            "
                  />
                </button>
              </nav>
            )}

            {mobileServices && !mobileCategory && (
              <div className="max-w-3xl mx-auto">
                {/* VOLVER */}
                <button
                  type="button"
                  onClick={() => setMobileServices(false)}
                  className="
            group
            flex
            items-center
            gap-2
            mb-5
            text-xs
            font-bold
            uppercase
            text-gray-500
            transition-colors
            duration-300
            hover:text-[#f37021]
          "
                >
                  <ArrowLeft
                    className="
              w-4
              h-4
              stroke-gray-500
              transition-all
              duration-300
              group-hover:stroke-[#f37021]
              group-hover:-translate-x-1
            "
                  />
                  Menú principal
                </button>

                <div className="mb-5">
                  <h2
                    className="
              text-lg
              font-bold
              text-[#111]
            "
                  >
                    Servicios
                  </h2>

                  <p
                    className="
              text-xs
              text-gray-400
              mt-1
            "
                  >
                    Selecciona una categoría
                  </p>
                </div>

                {/* CATEGORÍAS */}
                <div
                  className="
            grid
            grid-cols-2
            gap-3
          "
                >
                  {/* OIL & GAS */}
                  <button
                    type="button"
                    onClick={() => openCategory("oil")}
                    className="
              group
              text-left
              p-4
              rounded-2xl
              border
              border-orange-100
              bg-orange-50/40
              hover:bg-orange-50
              hover:border-orange-200
              transition-all
              duration-300
              hover:-translate-y-1
              hover:shadow-[0_10px_25px_rgba(238,125,50,0.10)]
            "
                  >
                    <div
                      className="
                w-10
                h-10
                rounded-xl
                bg-white
                flex
                items-center
                justify-center
                mb-3
                transition-all
                duration-300
                group-hover:scale-105
                group-hover:rotate-3
              "
                    >
                      <Droplets
                        className="
                  w-5
                  h-5
                  stroke-[#999]
                  transition-all
                  duration-300
                  group-hover:stroke-[#f37021]
                  group-hover:scale-110
                "
                      />
                    </div>

                    <h3
                      className="
                text-sm
                font-bold
                text-[#111]
                transition-colors
                duration-300
                group-hover:text-[#f37021]
              "
                    >
                      Oil & Gas
                    </h3>

                    <p
                      className="
                text-[11px]
                text-gray-500
                mt-1
              "
                    >
                      5 servicios
                    </p>

                    <div className="flex justify-end mt-3">
                      <ArrowRight
                        className="
                  w-4
                  h-4
                  stroke-[#999]
                  transition-all
                  duration-300
                  group-hover:stroke-[#f37021]
                  group-hover:translate-x-1
                "
                      />
                    </div>
                  </button>

                  {/* AMBIENTAL */}
                  <button
                    type="button"
                    onClick={() => openCategory("environmental")}
                    className="
              group
              text-left
              p-4
              rounded-2xl
              border
              border-green-100
              bg-green-50/40
              hover:bg-green-50
              hover:border-green-200
              transition-all
              duration-300
              hover:-translate-y-1
              hover:shadow-[0_10px_25px_rgba(34,197,94,0.10)]
            "
                  >
                    <div
                      className="
                w-10
                h-10
                rounded-xl
                bg-white
                flex
                items-center
                justify-center
                mb-3
                transition-all
                duration-300
                group-hover:scale-105
                group-hover:-rotate-3
              "
                    >
                      <Leaf
                        className="
                  w-5
                  h-5
                  stroke-[#999]
                  transition-all
                  duration-300
                  group-hover:stroke-green-600
                  group-hover:scale-110
                "
                      />
                    </div>

                    <h3
                      className="
                text-sm
                font-bold
                text-[#111]
                transition-colors
                duration-300
                group-hover:text-green-600
              "
                    >
                      Ambiental
                    </h3>

                    <p
                      className="
                text-[11px]
                text-gray-500
                mt-1
              "
                    >
                      6 servicios
                    </p>

                    <div className="flex justify-end mt-3">
                      <ArrowRight
                        className="
                  w-4
                  h-4
                  stroke-[#999]
                  transition-all
                  duration-300
                  group-hover:stroke-green-600
                  group-hover:translate-x-1
                "
                      />
                    </div>
                  </button>
                </div>
              </div>
            )}

            {/* OIL & GAS */}
            {mobileCategory === "oil" && (
              <div className="max-w-3xl mx-auto">
                {/* VOLVER */}
                <button
                  type="button"
                  onClick={backToServices}
                  className="
            group
            flex
            items-center
            gap-2
            mb-5
            text-xs
            font-bold
            uppercase
            text-gray-500
            transition-colors
            duration-300
            hover:text-[#f37021]
          "
                >
                  <ArrowLeft
                    className="
              w-4
              h-4
              stroke-gray-500
              transition-all
              duration-300
              group-hover:stroke-[#f37021]
              group-hover:-translate-x-1
            "
                  />
                  Servicios
                </button>

                <div
                  className="
            flex
            items-center
            gap-3
            mb-4
          "
                >
                  <div
                    className="
              group/icon
              w-10
              h-10
              rounded-xl
              bg-orange-50
              flex
              items-center
              justify-center
              transition-all
              duration-300
              hover:scale-105
            "
                  >
                    <Droplets
                      className="
                w-5
                h-5
                stroke-[#999]
                transition-all
                duration-300
                group-hover/icon:stroke-[#f37021]
                group-hover/icon:scale-110
                group-hover/icon:rotate-6
              "
                    />
                  </div>

                  <div>
                    <h3
                      className="
                font-bold
                text-[#111]
              "
                    >
                      Oil & Gas
                    </h3>

                    <p
                      className="
                text-xs
                text-gray-400
              "
                    >
                      Soluciones industriales
                    </p>
                  </div>
                </div>

                {/* SERVICIOS OIL & GAS */}
                <div
                  className="
            grid
            grid-cols-1
            sm:grid-cols-2
            gap-2
          "
                >
                  {oilGasServices.map((item) => (
                    <Link
                      key={item.path}
                      to={item.path}
                      onClick={closeMobileMenu}
                      className="
                group
                flex
                items-center
                justify-between
                gap-3
                p-3.5
                rounded-xl
                border
                border-gray-100
                bg-white
                hover:border-orange-200
                hover:bg-orange-50/40
                transition-all
                duration-300
                hover:-translate-y-0.5
              "
                    >
                      <span
                        className="
                  text-xs
                  sm:text-sm
                  text-gray-600
                  transition-colors
                  duration-300
                  group-hover:text-[#f37021]
                "
                      >
                        {item.label}
                      </span>

                      <ArrowRight
                        className="
                  w-4
                  h-4
                  shrink-0
                  stroke-[#999]
                  transition-all
                  duration-300
                  group-hover:stroke-[#f37021]
                  group-hover:translate-x-1
                "
                      />
                    </Link>
                  ))}
                </div>
              </div>
            )}

            {/* AMBIENTAL */}
            {mobileCategory === "environmental" && (
              <div className="max-w-3xl mx-auto">
                {/* VOLVER */}
                <button
                  type="button"
                  onClick={backToServices}
                  className="
            group
            flex
            items-center
            gap-2
            mb-5
            text-xs
            font-bold
            uppercase
            text-gray-500
            transition-colors
            duration-300
            hover:text-green-600
          "
                >
                  <ArrowLeft
                    className="
              w-4
              h-4
              stroke-gray-500
              transition-all
              duration-300
              group-hover:stroke-green-600
              group-hover:-translate-x-1
            "
                  />
                  Servicios
                </button>
                <div
                  className="
            flex
            items-center
            gap-3
            mb-4
          "
                >
                  <div
                    className="
              group/icon
              w-10
              h-10
              rounded-xl
              bg-green-50
              flex
              items-center
              justify-center
              transition-all
              duration-300
              hover:scale-105
            "
                  >
                    <Leaf
                      className="
                w-5
                h-5
                stroke-[#999]
                transition-all
                duration-300
                group-hover/icon:stroke-green-600
                group-hover/icon:scale-110
                group-hover/icon:-rotate-6
              "
                    />
                  </div>

                  <div>
                    <h3
                      className="
                font-bold
                text-[#111]
              "
                    >
                      Ambiental
                    </h3>

                    <p
                      className="
                text-xs
                text-gray-400
              "
                    >
                      Gestión y sostenibilidad
                    </p>
                  </div>
                </div>

                {/* SERVICIOS AMBIENTALES */}
                <div
                  className="
            grid
            grid-cols-1
            sm:grid-cols-2
            gap-2
          "
                >
                  {environmentalServices.map((item) => (
                    <Link
                      key={item.path}
                      to={item.path}
                      onClick={closeMobileMenu}
                      className="
                group
                flex
                items-center
                justify-between
                gap-3
                p-3.5
                rounded-xl
                border
                border-gray-100
                bg-white
                hover:border-green-200
                hover:bg-green-50/40
                transition-all
                duration-300
                hover:-translate-y-0.5
              "
                    >
                      <span
                        className="
                  text-xs
                  sm:text-sm
                  text-gray-600
                  transition-colors
                  duration-300
                  group-hover:text-green-600
                "
                      >
                        {item.label}
                      </span>

                      <ArrowRight
                        className="
                  w-4
                  h-4
                  shrink-0
                  stroke-[#999]
                  transition-all
                  duration-300
                  group-hover:stroke-green-600
                  group-hover:translate-x-1
                "
                      />
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </header>

      <div
        className="
          h-[78px]
          sm:h-[84px]
          xl:h-[94px]
        "
      />
    </>
  );
};

export default Header;
